import { render, staticRenderFns } from "./MaintenancesDetails.vue?vue&type=template&id=1a320fbb&scoped=true&"
import script from "./MaintenancesDetails.vue?vue&type=script&lang=js&"
export * from "./MaintenancesDetails.vue?vue&type=script&lang=js&"
import style0 from "./MaintenancesDetails.vue?vue&type=style&index=0&id=1a320fbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a320fbb",
  null
  
)

component.options.__file = "MaintenancesDetails.vue"
export default component.exports